import type { Theme } from './types';

/**
 * NEON SÀI GÒN — gần đen, hồng điện và lam ngọc, góc vuông, chữ hẹp.
 *
 * Ngược hẳn Ngọc Bích trên mọi trục. Nền gần như đen tuyệt đối để hai màu neon nổi
 * bật; góc bo bằng 0 nên mọi khối đều là hình chữ nhật sắc cạnh; mục đang chọn không
 * gạch chân mà **phát sáng**; bộ chữ tiêu đề hẹp và cao, viết hoa toàn bộ.
 *
 * Tính cách: ồn ào, trẻ, tốc độ — hợp thương hiệu chạy quay hũ và xổ số siêu tốc.
 *
 * Một lưu ý về khả năng đọc: màu chủ đạo hồng điện chỉ dùng cho **dấu hiệu và mục
 * đang chọn**, không bao giờ làm nền cho đoạn văn dài. Chữ nội dung vẫn là màu trung
 * tính sáng để tương phản đạt ngưỡng đọc được.
 */
export const neonSaiGon: Theme = {
  id: 'neon-sai-gon',
  brandName: 'NEON SÀI GÒN',
  tagline: 'Gần đen, hồng điện, góc vuông — ồn ào và nhanh.',

  scheme: 'dark',
  layout: 'wide',
  navStyle: 'glow',
  mark: 'tia-chop',

  fonts: {
    display: "'Oswald'",
    body: "'Be Vietnam Pro'",
    href: 'https://fonts.googleapis.com/css2?family=Oswald:wght@500;600;700&family=Be+Vietnam+Pro:wght@400;500;600;700&display=swap',
  },

  tokens: {
    'bg-root': '#07060c',
    'bg-surface': '#100e18',
    'bg-raised': '#191626',
    'bg-overlay': '#211d31',
    'bg-input': '#0b0912',
    'bg-hover': '#251f38',

    brand: '#ff2d92',
    'brand-strong': '#ff63ac',
    'brand-dim': '#8f1152',
    'brand-contrast': '#07060c',
    accent: '#00e0ff',

    positive: '#00e08a',
    'positive-dim': '#0a5238',
    negative: '#ff3d5a',
    'negative-dim': '#611220',
    warning: '#ffb800',
    info: '#00e0ff',
    'odds-up': '#00e08a',
    'odds-down': '#ff3d5a',

    'text-primary': '#f2eef8',
    'text-secondary': '#a49bbb',
    'text-muted': '#6f6689',
    'text-disabled': '#48425c',
    'text-on-brand': '#07060c',
    'text-inverse': '#07060c',

    border: '#2a2440',
    'border-strong': '#413764',

    // Bóng mang màu chứ không phải màu đen: trên nền gần đen, bóng đen vô hình.
    'shadow-sm': '0 0 0 1px rgb(255 45 146 / 12%)',
    'shadow-md': '0 4px 20px rgb(255 45 146 / 14%)',
    'shadow-lg': '0 0 42px rgb(255 45 146 / 22%)',

    'font-display': "'Oswald', 'Arial Narrow', 'Segoe UI', sans-serif",
    'font-sans': "'Be Vietnam Pro', 'Segoe UI', system-ui, sans-serif",

    // Góc vuông tuyệt đối, kể cả chỗ mặc định là viên thuốc (xem `radius-full` bên dưới).
    'radius-sm': '0px',
    'radius-md': '0px',
    'radius-lg': '2px',
    'radius-xl': '2px',
    /* `--radius-full` la khoa hinh VIEN THUOC (the, nhan, tab), khong phai hinh tron
       tuyet doi — khong cho nao dung no cho anh dai dien hay cham tron. Nen mot thuong
       hieu lay goc vuong lam nhan dien duoc phep vuong hoa ca nhung cho nay; de nguyen
       999px thi nut chinh bo tron lop lop giua mot trang toan goc nhon, nhin ra ngay
       la hai bo quy tac danh nhau.
       Vuong theo ca giao dien. */
    'radius-full': '2px',

    'header-height': '60px',
    // Tràn hết bề ngang màn hình, không kẹp lại.
    'content-max': '100%',
    'brand-tracking': '0.16em',
    'label-tracking': '0.09em',
    'label-transform': 'uppercase',
  },
};
